import { Component, OnInit } from '@angular/core';
import { StoreService } from 'src/app/store.service';
import { NavigationExtras, ActivatedRoute, Router } from '@angular/router';
import { FormBuilder, FormGroup, NgForm } from '@angular/forms';


@Component({
  selector: 'app-product-manager-form',
  templateUrl: './product-manager-form.component.html',
  styleUrls: ['./product-manager-form.component.scss']
})
export class ProductManagerFormComponent implements OnInit {

  public ckData;
  public ckDescription = '';
  public ckConfig = {
    toolbar: [ 'bold', 'italic', 'bulletedList', 'numberedList', 'indent', 'outdent' ]
  };

  public files: any[];

  imagePath: any;
  imgURL: any;
  message: string;

  store_id;
  bearer;
  country = [];
  customerProductForm: FormGroup;

  buildForm() {
    this.customerProductForm = this.formBuilder.group({
      product_name: [''],
      product_overview: [''],
      product_desc:[''],
      store_id:[''],
      language_code:[''],
      product_id:[''],
      primary_photo:[''],
    });

  }

  constructor(
    private svc: StoreService,
    private router: Router,
    private formBuilder: FormBuilder,
  ) { }


  ngOnInit(): void {
    this.bearer = localStorage.getItem('bearer');
    this.customerProductForm = this.formBuilder.group({
      product_name: [''],
      product_overview: [''],
      product_desc:[''],
      store_id:[''],
      language_code:[''],
      product_id:[''],
      primary_photo:[''],
    });
    this.ionViewDidEnter()
  }

  ionViewDidEnter() {

    }



    createCustomerProduct(){
      this.bearer = localStorage.getItem('bearer');
      console.log('token',this.bearer);
      this.customerProductForm.value['language_code'] = 'en-US';
      this.customerProductForm.value['store_id'] = 1;
      console.log('store_id',this.customerProductForm.value['store_id']);
      this.svc.createProductCustom(this.customerProductForm.value['store_id'], this.customerProductForm.value['language_code'], this.customerProductForm.value['product_name'],this.customerProductForm.value['product_desc'], this.customerProductForm.value['product_overview'] , this.imgURL ,this.bearer).subscribe(
        data => {
          console.log('done Create');
          this.router.navigate(['/dashboard/product-manager']);
        },
        error => {

        },
      );
    }

    preview(files: any) {
    if (files.length === 0) {
          return;
    }

    var mimeType = files[0].type;
    if (mimeType.match(/image\/*/) == null) {
      this.message = "Only images are supported.";
      return;
    }

    var reader = new FileReader();
    this.imagePath = files;
    reader.readAsDataURL(files[0]);
    reader.onload = (_event) => {
      this.imgURL = reader.result;
      console.log(this.imgURL);

    }
  }



}
